// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","316":"e0f6add9","320":"530c6b99","931":"76a51d99"}[chunkId] + ".chunk.js";
};